const s = {
  name: "Printer",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M33,2H7V0h26V2z"/>
		<path class="st0" d="M35.3,10c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C34.7,8.8,35.3,9.3,35.3,10z"/>
		<path class="st0" d="M29,23H11v2h18V23z"/>
		<path class="st0" d="M11,27h18v2H11V27z"/>
		<path class="st0" d="M7,25H5c-2.8,0-5-2.2-5-5V9c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v11c0,2.8-2.2,5-5,5h-2v9H7V25z M2,9v11
			c0,1.7,1.3,3,3,3h2v-5h26v5h2c1.7,0,3-1.3,3-3V9c0-1.7-1.3-3-3-3H5C3.3,6,2,7.3,2,9z M9,32h22V20H9V32z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Printer
};
